const smartBar = {
  more: "עוד",
  overflow: "ווידג׳טים נוספים",
  lockWidget: "נעל ווידג׳ט",
  unlockWidget: "שחרר נעילה",
  pinnedSettings: "הגדרות",
  pinnedStore: "חנות ווידג׳טים",
  searchShortcuts: "חיפוש...",
  barSettings: "הגדרות סרגל",
  widgetSettings: "הגדרות ווידג׳ט",
  info: "מידע",
  customIcon: "אייקון מותאם",
  defaultSize: "גודל ברירת מחדל",
  category: "קטגוריה",
  status: "סטטוס",
} as const;
export default smartBar;
